import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import JobForm from './JobForm';

// Page variant of the canonical JobForm — /admin/jobs/new.
// Optional ?client=<id> preselects the client (used from client pages).
export default function JobsNew() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get('client') || '';

  return (
    <JobForm
      variant="page"
      clientId={clientId}
      onSaved={(job) => navigate(`/admin/jobs/${job.id}`)}
    />
  );
}
